export const GoogleMapApiConfig = 'AIzaSyAZx74_0oUlYbcA7wiBYnymPscTO9cyXxI';